export default "__VITE_ASSET__CowU9gR4__"